import React, { useLayoutEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import NumerologyAccessGate from './NumerologyAccessGate';
import NumerologyHeader from './NumerologyHeader';
import NumerologyShellChrome from './NumerologyShellChrome';

/**
 * Shell for all /numerology/* routes: global brand header + AMM-scoped surface + centered wrap + secondary nav.
 * Legacy redirects (mini-course, learn, samples, etc.) are nested here so the header is never skipped.
 * Robots noindex is applied in AppShell when pathname is under /numerology.
 *
 * Scroll: on PUSH/REPLACE navigations, reset window scroll so Study articles, hub → study,
 * samples → report, and report ?sample= changes land at the top. POP (back/forward) is left
 * to the browser so history scroll restoration still works.
 */
export default function NumerologyLayout() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, navigationType]);

  return (
    <NumerologyShellChrome>
      <NumerologyAccessGate>
        <>
          <NumerologyHeader />
          <div className="amm-wrap amm-wrap--numerology-flex">
            <Outlet />
          </div>
        </>
      </NumerologyAccessGate>
    </NumerologyShellChrome>
  );
}
